export interface VerifyPayeeResponse {
	id: string;
	user_id: string;
	result: VerifyPayeeResult;
	result_reported_account_holder: string;
}

export interface VerifyPayeePayload {
	iban: string;
	name: string;
	currency: string;
}

export enum VerifyPayeeResult {
	FULL_MATCH = "FULL_MATCH",
	CLOSE_MATCH = "CLOSE_MATCH",
	NO_MATCH = "NO_MATCH",
	NOT_APPLICABLE = "NOT_APPLICABLE",
	ERROR = "ERROR"
}

export enum VerifyPayeeMode {
	SEND = "send",
	WITHDRAWAL = "withdrawal"
}
